import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    getProductFeedbackService,
    ProductFeedbackModel,
} from "@tCentro/Services/CENProductDetailsFeedbackModalService";

type HandlerType = Handler<ProductFeedbackModel> & HasOnSuccess;

export const PopulateApiParameter: HandlerType = (props: any) => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async (props: any) => {
    props.apiResult = await getProductFeedbackService(props.apiParameter);
};

export const chain = [PopulateApiParameter, RequestDataFromApi];

const submitFeedbackModal = createHandlerChainRunner(chain, "CENProductDetailsFeedbackModal");

export default submitFeedbackModal;
